import { useState, useRef, useEffect } from "react";
import "../assets/styles/editor.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faChartBar,
  faPause,
  faPlay,
  faVolumeMute, faVolumeUp,
  faTrash,
  faExclamationCircle,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
import { createFFmpeg } from "@ffmpeg/ffmpeg";
import { FrameTime } from "./FrameTimeV1";
import { SelectedTimeFrame } from "./SelectedTimeFrame";
import {
  frameViewColor,
  scameTimeMeasure,
} from "../assets/constants/constants";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { AlertMessageBox, triggerAlert } from "./AlertMessage";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import {
  Paper,
  Checkbox,
  FormControlLabel,
  Divider
} from "@mui/material";
import usePreventZoom from '../common_functions/usepreventzoom'
import ROISelector from "./ROISelector";
import Tooltip from '@mui/material/Tooltip';
import MeasurementsModal from "./MeasureModal";
import ExportChartData from "./ChartData";
import { download_meta_file, download_video_frames } from "../assets/constants/global_apis";
import { calculateBoxPercentage, calculateBoxFromPercentage, generateUniqueColors } from "../common_functions/video_annotator_functions";
import { GradientCircularProgress } from "./Loader";
const modalStyle = {
  position: 'absolute',
  top: '45%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  height: 200,
  pt: 2,
  paddingLeft: 0,
  paddingRight: 0,
};

const shortCutsList = [
  {
    key: 'delete',
    event: 'Deletes the selected sublabel timing'
  },
  {
    key: 'Cntrl+Scroll Up',
    event: 'Zooms in annotator label lines'
  },
  {
    key: 'Cntrl+Scroll Down',
    event: 'Zooms out annotator label lines'
  },
  {
    key: 'Cntrl+s',
    event: 'Saves the Annotation into File'
  },
  {
    key: 'Cntrl+ +',
    event: 'Zoom In Time Frame'
  },
  {
    key: 'Cntrl+ -',
    event: 'Zoom Out Time Frame'
  }
]

export const VideoAnnotator = ({
  videoUrl,
  timings,
  setTimings,
  annotationData,
  labelsLi,
  currentlabel,
  onchangeHandlerLabel,
  handleSubmit,
  videoFrameCount,
  roiList,
  setroiList,
  urlParams,
  addRoiCoordinates,
  updateRoiCoordinates,
  deleteRoiCoordinates
}) => {
  const [isMuted, setIsMuted] = useState(false);
  const [openChartData, setOpenChartData] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [seekerBar, setSeekerBar] = useState(0);
  const playVideoRef = useRef();
  const roiDrawRef = useRef(null);
  const progressBarRef = useRef();
  const progressBarRef1 = useRef();
  const playBackBarRef = useRef();
  const controllerWrapperRef = useRef();
  const playBackBarRef1 = useRef();
  const scrollBarRef = useRef();
  const ffmpeg = useRef(null);
  const [videoTiming, setVideoTiming] = useState(0);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [frameInterval, setFrameInterval] = useState(5)
  const [analyticData, setAnalyticData] = useState({
    mean: 0,
    median: 0,
    min: 0,
    max: 0
  })
  const [exportFrameLoader, setEportFrameLoader] = useState(false)
  const [sublabelTimings, setsubLabelTimings] = useState(
    annotationData?.labels[0]?.sublabels
  );
  const [filteredSublabelTimings, setfilteredSublabelTimings] = useState(
    annotationData?.labels[0]?.sublabels.slice(0, annotationData?.labels[0]?.sublabels.length)
  );
  const [selectAll, setSelectAll] = useState(true);
  const [progressBarTimStmp, setprogressBarTimStmp] = useState(-1);
  const [hoverTimeLft, sethoverTimeLft] = useState(0);
  const [currentVideoPlayTime, setCurrentVideoPlayTime] = useState(0);
  const [selectedLabelTab, setselectedLabelTab] = useState({
    ...annotationData?.labels[0]?.sublabels[0]?.timings[0],
    accindex: 0,
    timingindx: 0,
    currentGrabbed: "start",
    frameLabel: {
      start: 0,
      end: 120,
      accindex: 0,
      timingindx: 0,
      currentGrabbed: "start",
    },
  });
  const [playbackLength, setplayBackLength] = useState(
    window.screen.availWidth * 0.8
  );
  const [labelContainerHeight, setLabelContainerHeight] = useState(
    window.screen.availHeight * 0.2
  );
  const [frames, setframes] = useState([]);
  const [isGetFrameChecked, setisGetFrameChecked] = useState(false);
  const [isFrameEnabled, setisFrameEnabled] = useState(true);
  const [timing1, settiming1] = useState([]);
  const [grabberColors, setgrabberColors] = useState([])
  const [timeEnd, setTimeEnd] = useState(0);
  const [openlabelSelector, setOpenlabelSelector] = useState(false);
  const [modalType, setmodalType] = useState('');
  const [showAlertBox, setShowAlertBox] = useState(false);
  const [progressBarTime, setProgressBarTime] = useState(0);
  const [alertMessage, setAlertMessage] = useState({
    Errortype: "Error",
    title: "",
    message: "",
  });
  const [currentPlayFrame, setcurrentPlayFrame] = useState({
    accindex: -1,
    timingindx: -1,
  });
  const [isLabelVideoPlayerOn, setisLabelVideoPlayerOn] = useState(false);
  const [editableInp, setEditableInp] = useState({
    accindex: -1,
    timingindx: -1,
    currentGrabbed: '',
    currentValue: ''
  });
  const [frameCount, setFrameCount] = useState(videoFrameCount);
  const [frameTimeLimit, setframeTimeLimit] = useState(parseFloat((1 / videoFrameCount).toFixed(10)));
  const [timeFrameLimit, settimeFrameLimit] = useState([]);
  const frameLabels = useRef("");
  let [digitslngth, setdigitslngth] = useState(String(parseFloat((1 / videoFrameCount).toFixed(10))).length);
  const firstDivRef = useRef();
  const secondDivRef = useRef();
  const [zoomAreaRatio, setZoomAreaRatio] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0
  });
  const [zoomArea, setZoomArea] = useState(null);
  const [visibleVideoDimensions, setVisibleVideoDimensions] = useState({
    width: 0,
    height: 0,
    videoWidth: 0,
    videoheight: 0
  })
  const [showCroppedVideo, setShowCroppedVideo] = useState(false);
  const [enableROI, setEnableROI] = useState(false);
  const [selecteROIindex, setSelecteROIindex] = useState(0);
  const [selectedEditableROIindex, setSelectedEditableROIindex] = useState(-1);
  const [measurements, setMeasurements] = useState({
    width: 0,
    height: 0,
    x: 0,
    y: 0,
    editable: false
  });

  useEffect(() => {
    let measurementValues = {};
    let zoomRatio = (enableROI ? { ...calculateBoxPercentage(visibleVideoDimensions.width, visibleVideoDimensions.height, zoomArea != null ? zoomArea.x : 0, zoomArea != null ? zoomArea.y : 0, zoomArea != null ? zoomArea.width : 0, zoomArea != null ? zoomArea.height : 0) } : { ...zoomAreaRatio });
    if (enableROI) {
      measurementValues = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, zoomRatio.x, zoomRatio.y, zoomRatio.width, zoomRatio.height)
      measurementValues = { ...measurementValues, editable: true }
    } else if (!enableROI && selecteROIindex != 0 && selectedEditableROIindex == -1) {
      measurementValues = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, zoomRatio.x, zoomRatio.y, zoomRatio.width, zoomRatio.height)
      measurementValues = { ...measurementValues, editable: false }
    } else if (!enableROI && selecteROIindex == 0 && selectedEditableROIindex != -1) {
      measurementValues = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, zoomRatio.x, zoomRatio.y, zoomRatio.width, zoomRatio.height)
      measurementValues = { ...measurementValues, editable: enableROI ? true : false }
    } else {
      measurementValues = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, zoomRatio.x, zoomRatio.y, zoomRatio.width, zoomRatio.height)
      measurementValues = { ...measurementValues, editable: false }
    }
    if (zoomArea == null && selecteROIindex == 0 && selectedEditableROIindex == -1) {
      setMeasurements({
        width: 0,
        height: 0,
        x: 0,
        y: 0,
        editable: true
      });
    } else {
      setMeasurements(measurementValues)
    }
  }, [selecteROIindex, visibleVideoDimensions])
  const onchangeScroll = (e) => {
    e.stopPropagation();
    if (playbackLength - e?.deltaY > window.screen.availWidth * 0.76) {
      setplayBackLength((prevState) => prevState - e.deltaY);
    } else if (e?.deltaY < 0) {
      setplayBackLength((prevState) => prevState - e.deltaY);
    }
  };
  const handleKeyZoom = (e) => {
    // Normalize key values
    const isPlus = e?.key === '+' || e?.key === '='; // Some layouts use '=' for +
    const isMinus = e.key === '-';

    if (isPlus || isMinus) {
      e.preventDefault();

      // Optional: Check for ctrlKey if you want Ctrl+Zoom only
      // if (!e.ctrlKey) return;

      const zoomDelta = isPlus ? -100 : 100;

      setplayBackLength((prevState) => {
        const newLength = prevState - zoomDelta;
        const minLength = window.screen.availWidth * 0.76;
        return newLength >= minLength ? newLength : prevState;
      });
    }
  };
  usePreventZoom(true, true, onchangeScroll, playbackLength);

  const handleScrollFirst = scroll => {
    secondDivRef.current.scrollTop = scroll.target.scrollTop;
  };

  const handleScrollSecond = scroll => {
    firstDivRef.current.scrollTop = scroll.target.scrollTop;
  };

  Number.prototype.round = function (places) {
    return +(Math.round(this + "e+" + places) + "e-" + places);
  }
  const handleSpeedChange = (event) => {
    const selectedRate = parseFloat(event.target.value);
    if (playVideoRef?.current) {
      playVideoRef.current.playbackRate = selectedRate==3 ? selectedRate-0.01 : selectedRate;
      setPlaybackRate(selectedRate);
    }
  };

  const openAlertPopup = () => {
    setShowAlertBox(true);
    setTimeout(function () {
      setShowAlertBox(false);
    }, 2000);
  };
  useEffect(() => {
    if (annotationData?.labels[0]?.sublabels.length != sublabelTimings.length) {
      setfilteredSublabelTimings(sublabelTimings);
    }
  }, [sublabelTimings])

  const handleOpenLabelSelector = () => setOpenlabelSelector(true);
  const handleCloseLabelSelector = () => setOpenlabelSelector(false);
  const handleOpenChartData = () => setOpenChartData(true);
  const handleCloseChartData = () => setOpenChartData(false);

  function storeFrame(video, context, canvas, resolve) {
    context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    resolve(canvas.toDataURL());
  }

  // const getVideoFrame = async (video, context, canvas, time) => {
  //   return new Promise((resolve, reject) => {
  //     let eventCallback = () => {
  //       video.removeEventListener("seeked", eventCallback);
  //       storeFrame(video, context, canvas, resolve);
  //     };
  //     video.addEventListener("seeked", eventCallback);
  //     video.currentTime = time;
  //   });
  // };

  // async function getFrames(amount, type) {
  //   return new Promise((resolve, reject) => {
  //     let video_Url = videoUrl;
  //     let frames = [];
  //     let canvas = document.createElement("canvas");
  //     let context = canvas.getContext("2d");
  //     let duration;

  //     let video = document.createElement("video");
  //     video.preload = "autos";
  //     video.addEventListener("loadeddata", async function () {
  //       canvas.width = video.videoWidth;
  //       canvas.height = video.videoHeight;
  //       duration = selectedLabelTab.end;

  //       let totalFrames = amount;
  //       if (type === 0) {
  //         totalFrames = duration * amount;
  //       }

  //       for (
  //         let time = selectedLabelTab.start;
  //         time < duration;
  //         time += 1 / frameCount
  //       ) {
  //         frames.push({
  //           imgUrl: await getVideoFrame(video, context, canvas, time),
  //           time: time,
  //         });
  //       }
  //       resolve(frames);
  //     });
  //     video.src = video_Url;
  //     video.load();
  //   });
  // }

  const load = async () => {
    try {
      await ffmpeg.current.load();
    } catch (error) { }
  };

  useEffect(() => {
    ffmpeg.current = createFFmpeg({
      log: true,
      corePath: "https://unpkg.com/@ffmpeg/core@0.10.0/dist/ffmpeg-core.js",
    });
    load();
  }, []);

  useEffect(() => {
    const keyEventOperations = (event) => {
      const key = event.key;
      if (key === "Delete" && selectedLabelTab?.accindex != -1 && selectedLabelTab?.timingindx != -1) {
        let tmpSublabel = [...sublabelTimings];
        let timingsval = [...tmpSublabel[selectedLabelTab.accindex].timings],
          dta = [];
        for (let i = 0; i < timingsval.length; i++) {
          if (i != selectedLabelTab?.timingindx) {
            dta.push(timingsval[i]);
          }
        }
        tmpSublabel[selectedLabelTab.accindex].timings = dta;
        setselectedLabelTab({
          ...tmpSublabel[selectedLabelTab.accindex].timings[0],
          accindex: selectedLabelTab.accindex,
          timingindx: 0,
          currentGrabbed: "start",
          frameLabel: {
            start: 0,
            end: 120,
            accindex: selectedLabelTab.accindex,
            timingindx: 0,
            currentGrabbed: "start",
          },
        });
        setsubLabelTimings(tmpSublabel);
      }
      else if (event?.key === 's' && event?.ctrlKey) {
        event.preventDefault()
        handleSubmit(sublabelTimings)
      }
      else if ((event.key === '+' || event.key === '=')  && event?.ctrlKey) {
        event.preventDefault();
        handleKeyZoom(event);
      } // Ctrl + '-' for zoom out
      if (event.key === '-'  && event?.ctrlKey) {
        event.preventDefault();
        handleKeyZoom(event);
      }
    };
    window.addEventListener("keydown", keyEventOperations, false);
    return () => window.removeEventListener("keydown", keyEventOperations, false);
  }, [selectedLabelTab, sublabelTimings]);

  const updateTime = () => {
    if (timings[0] && timings[0]?.end) {
      let n = timings[0].end;
      let result = [],
        j = (1 / frameTimeLimit) % 1 != 0 ? (frameTimeLimit * frameCount) + frameTimeLimit : 1;
      while (j <= n) {
        result.push(parseFloat(j.toFixed(2)));
        j += frameTimeLimit;
      }
      settiming1(result);
      setTimeEnd(n);
    }
  };

  // useEffect(() => {
  //   if (isGetFrameChecked) {
  //     getFrames(Math.floor(playbackLength / 35), 10)
  //       .then((result) => {
  //         setframes(result);
  //       })
  //       .catch((e) => {
  //         console.log("Error:", e);
  //       });
  //   }
  // }, [selectedLabelTab, isGetFrameChecked]);



  useEffect(() => {
    if (playVideoRef?.current?.onloadedmetadata) {
      if (playVideoRef?.current?.onloadedmetadata && playVideoRef?.current.currentTime == videoTiming) {
        playVideoRef.current.currentTime = videoTiming;
        setCurrentVideoPlayTime(videoTiming)
        handlePauseVideo();
        setPlaying(false);
      } else {
        const seek =
          ((playVideoRef.current.currentTime - timings[0]?.start) /
            playVideoRef.current.duration) *
          100;
        const currentTimeLabels = [], seek1 = parseFloat((playVideoRef.current.currentTime).toFixed(6));
        sublabelTimings.map((sublabel, index) => {
          for (let i = 0; i < sublabel.timings.length; i++) {
            if (parseFloat(sublabel?.timings[i]?.start) <= seek1 && parseFloat(sublabel?.timings[i]?.end) >= seek1) {
              currentTimeLabels.push(sublabel.subname);
              break;
            }
          }
        })
        frameLabels.current = String(currentTimeLabels.join(','));
        setSeekerBar(seek);

        let cpyseekerBar = seekerBar;
        if (+progressBarRef?.current.style.width > 100) {
          cpyseekerBar = 100 - (seekerBar + progressBarRef.current.style.width);
        }
        setCurrentVideoPlayTime(playVideoRef.current.currentTime)
        progressBarRef.current.style.width = `${cpyseekerBar}%`;
        progressBarRef1.current.style.width = `${cpyseekerBar}%`;
        if (
          (!isLabelVideoPlayerOn &&
            playVideoRef?.current.currentTime >= timings[0]?.end) ||
          (isLabelVideoPlayerOn &&
            playVideoRef?.current.currentTime >=
            sublabelTimings[currentPlayFrame?.accindex]?.timings[
              currentPlayFrame?.timingindx
            ]?.end)
        ) {
          handlePauseVideo();
          setPlaying(false);
          progressBarRef.current.style.width = "0%";
          progressBarRef.current.style.left = `${(timings[0]?.start / playVideoRef.current.duration) * 100
            }%`;
          progressBarRef1.current.style.width = "0%";
          progressBarRef1.current.style.left = `${(timings[0]?.start / playVideoRef.current.duration) * 100
            }%`;
          playVideoRef.current.currentTime = timings[0]?.start;
          roiDrawRef.current.currentTime = timings[0]?.start;
        }
      }
    }
    const time = timings;
    playVideoRef.current.onloadedmetadata = () => {
      if (time.length === 0) {
        time.push({ start: 0, end: playVideoRef.current.duration });
        let labelColors = generateUniqueColors(sublabelTimings.length);
        setgrabberColors(labelColors);
        setLabelContainerHeight(window.screen.availHeight < 850 ? window.screen.availHeight - firstDivRef.current.offsetTop - 124 : window.screen.availHeight - firstDivRef.current.offsetTop - 144)
        setTimings(time);
        updateTime();
        setVideoTiming(playVideoRef.current.duration);
        calculateAnalyticFields();
        addActiveSegments();
        let frameValSum = frameTimeLimit;
        while (frameValSum < 1) {
          timeFrameLimit.push(frameValSum);
          frameValSum = (frameValSum + frameTimeLimit).round(10);
        }
      } else {
        addActiveSegments();
      }
    };
  });

  const labelPlayPauseController = (e, accindx, timeindex, isLabelControll) => {
    let currentPlay = {};
    if (isLabelControll) {
      currentPlay = {
        accindex: accindx,
        timingindx: timeindex,
      };
      setcurrentPlayFrame(currentPlay);
      setisLabelVideoPlayerOn(true);
      if (playVideoRef?.current) {
        playVideoRef.current.currentTime = !(
          currentPlayFrame?.accindex == accindx &&
          currentPlayFrame?.timingindx == timeindex
        )
          ? sublabelTimings[accindx].timings[timeindex].start
          : playVideoRef?.current.currentTime <
            sublabelTimings[accindx]?.timings[timeindex]?.start
            ? sublabelTimings[accindx].timings[timeindex].start
            : playVideoRef?.current.currentTime >
              sublabelTimings[accindx]?.timings[timeindex]?.end
              ? playVideoRef?.current.currentTime <
              sublabelTimings[accindx]?.timings[timeindex]?.start
              : playVideoRef.current.currentTime;
      }
      progressBarRef.current.style.left = `${0}%`;
      progressBarRef1.current.style.left = `${0}%`;
      if (
        !(
          currentPlayFrame?.accindex == accindx &&
          currentPlayFrame?.timingindx == timeindex
        )
      ) {
        setPlaying(false);
      }
    } else {
      setisLabelVideoPlayerOn(false);
      setcurrentPlayFrame({
        accindex: -1,
        timingindx: -1,
      });
    }
    playPause(false, e, accindx, timeindex, isLabelControll);
  };

  //Function handling play and pause logic
  const playPause = (isMainController, e, accindx, timeindex, isLabelControll) => {
    try {
      if (isMainController == true) {
        setisLabelVideoPlayerOn(false);
        setcurrentPlayFrame({
          accindex: -1,
          timingindx: -1,
        });
      }
      if (playing) {
        handlePauseVideo();
      } else {
        if (isMainController == false) {
          if (
            (!isLabelControll &&
              playVideoRef?.current.currentTime >= timings[0]?.end) ||
            (isLabelControll &&
              playVideoRef?.current.currentTime >=
              sublabelTimings[accindx]?.timings[timeindex]?.end)
          ) {
            handlePauseVideo();
            setPlaying(false);
            progressBarRef.current.style.left = `${(timings[0].start / playVideoRef.current.duration) * 100
              }%`;
            progressBarRef.current.style.width = "0%";
            progressBarRef1.current.style.left = `${(timings[0].start / playVideoRef.current.duration) * 100
              }%`;
            progressBarRef1.current.style.width = "0%";
          }
        }
        try {
          handlePlayVideo()
        } catch (e) {
          console.log('Error: ', e);
        }
      }
      setPlaying(!playing);
    } catch {
      console.log("Player play pause issue")
    }
  };

  const updateProgresshoverTime = (event) => {
    let playbackRect = playBackBarRef.current.getBoundingClientRect();
    let seekTime =
      Math.floor(
        (((event.clientX - playbackRect.left) / playbackRect.width) *
          playVideoRef.current.duration) /
        frameTimeLimit
      ) * frameTimeLimit;
    let leftMv = (seekTime / playVideoRef.current.duration) * 100;
    setprogressBarTimStmp(getTimeandFrame(seekTime));
    sethoverTimeLft(leftMv);
  };

  const getSeekTime = (event, playbackRect) => {
    let seekTime = 0;
    if (
      event?.type == "frames" &&
      event?.accindex != -1 &&
      event?.timingindx != -1
    ) {
      seekTime = event?.time;
    } else if (event?.type == "frames") {
      seekTime = event?.time;
    } else {
      seekTime =
        Math.floor(
          (((event.clientX - playbackRect.left) / playbackRect.width) *
            playVideoRef.current.duration) /
          frameTimeLimit
        ) * frameTimeLimit;
    }
    if (currentPlayFrame?.accindex >= 0 && currentPlayFrame?.timingindx >= 0) {
      if (seekTime < sublabelTimings[currentPlayFrame?.accindex]?.timings[currentPlayFrame?.timingindx]?.start || seekTime > sublabelTimings[currentPlayFrame?.accindex]?.timings[currentPlayFrame?.timingindx]?.end) {
        setisLabelVideoPlayerOn(false);
        setcurrentPlayFrame({
          accindex: -1,
          timingindx: -1,
        });
      }
    }
    return seekTime;
  }

  //Function handling updating progress logic (clicking on progress bar to jump to different time durations)
  const updateProgress = (
    event,
    isMainTimeFrame = false,
    videoTimeFrameSelect = false
  ) => {
    let playbackRect = {};
    if (videoTimeFrameSelect) {
      playbackRect = playBackBarRef1.current.getBoundingClientRect();
    } else {
      playbackRect = playBackBarRef.current.getBoundingClientRect();
    }
    let seekTime = 0;
    if (
      event?.type == "frames" &&
      event?.accindex != -1 &&
      event?.timingindx != -1
    ) {
      seekTime = event?.time;
      handleMouseMoveWhenGrabbed(
        {
          ...event,
          seekratio: timings[0].start / playVideoRef.current.duration,
        },
        event.accindex,
        event.timingindx,
        event.currentGrabbed
      );
    } else if (event?.type == "frames") {
      seekTime = event?.time;
    } else {
      seekTime =
        Math.floor(
          (((event.clientX - playbackRect.left) / playbackRect.width) *
            playVideoRef.current.duration) /
          frameTimeLimit
        ) * frameTimeLimit;
    }
    seekTime = getSeekTime(event, playbackRect);
    setProgressBarTime(seekTime)
    try {
      handlePauseVideo();
      setPlaying(false);
    } catch (e) {
      console.log("Pause failed!!!")
    }
    // find where seekTime is in the segment
    let index = -1;
    let counter = 0;
    for (let times of timings) {
      if (seekTime >= times?.start && seekTime <= times?.end) {
        index = counter;
      }
      counter += 1;
    }
    if (index === -1) {
      return;
    }

    progressBarRef.current.style.width = "0%"; // Since the width is set later, this is necessary to hide weird UI
    progressBarRef.current.style.left = `${(timings[0].start / playVideoRef.current.duration) * 100
      }%`;
    progressBarRef1.current.style.width = "0%"; // Since the width is set later, this is necessary to hide weird UI
    progressBarRef1.current.style.left = `${(timings[0].start / playVideoRef.current.duration) * 100
      }%`;
    playVideoRef.current.currentTime = seekTime;
    roiDrawRef.current.currentTime = seekTime;

    if (isMainTimeFrame) {
      let sblbl = { ...selectedLabelTab },
        midValDiff =
          (selectedLabelTab.frameLabel.end -
            selectedLabelTab.frameLabel.start) /
          2;
      sblbl.frameLabel.start = seekTime - midValDiff;
      sblbl.frameLabel.end = seekTime + midValDiff;
      scrollBarRef.current.scrollLeft =
        ((selectedLabelTab.frameLabel.end - selectedLabelTab.frameLabel.start) *
          frameCount *
          5 -
          10) /
        2;
      if (seekTime - midValDiff <= 0) {
        sblbl.frameLabel.start = 0;
      }
      if (seekTime + midValDiff >= videoTiming) {
        sblbl.frameLabel.end = videoTiming;
      }
      if (seekTime - midValDiff > 0 && seekTime + midValDiff < videoTiming) {
        sblbl.frameLabel.start = seekTime - midValDiff;
        sblbl.frameLabel.end = seekTime + midValDiff;
      }
      setselectedLabelTab(sblbl);
    }
  };
// ----------------------------------------------------------------------------------------------

const check_available_space_add_label=(labelindx)=>{
    let tmpSublabel = [...sublabelTimings];
    let tmpSublabel1 = [...sublabelTimings];
    let crntSltdLabel = { ...selectedLabelTab };
    
    const requiredDuration = 20;
    const framePadding = frameTimeLimit * 2;
    let currentTime = null;
  
    // **Step 1: Sort timings to ensure order**
    tmpSublabel1[labelindx].timings.sort((a, b) => a.start - b.start);
  
    // **Step 2: Check for available slots between labels**
    let lastEnd = 0;
    let largestAvailable = null;
  
    for (let i = 0; i < tmpSublabel1[labelindx].timings.length; i++) {
      let rowtime = tmpSublabel1[labelindx].timings[i];
  
      let availableSpace = rowtime.start - lastEnd;
  
      // If there is an exact fit, place the label here
      if (availableSpace >= requiredDuration + framePadding) {
        currentTime = { start: lastEnd + framePadding, end: lastEnd + requiredDuration };
        break;
      }
  
      // Keep track of the largest available space
      if (!largestAvailable || availableSpace > largestAvailable.end - largestAvailable.start) {
        largestAvailable = { start: lastEnd + framePadding, end: rowtime.start };
      }
  
      lastEnd = rowtime.end;
    }
  
    // **Step 3: If no gap found, check if it fits after the last label**
    if (!currentTime && videoTiming - lastEnd >= requiredDuration + framePadding) {
      currentTime = { start: lastEnd + framePadding, end: lastEnd + requiredDuration };
    }
  
    // **Step 4: If no 20s slot available, fit within the largest available slot**
    if (!currentTime && largestAvailable && largestAvailable.end - largestAvailable.start > framePadding) {
      currentTime = { start: largestAvailable.start, end: largestAvailable.end };
    }
  
    // **Step 5: If still no space, throw an overlap error**
    if (!currentTime) {
      setAlertMessage({
        Errortype: "Info",
        title: "No Space Available",
        message: "Cannot add new label",
      });
      openAlertPopup();
      return;
    }
  
    console.log("Final Label Placement:", currentTime);
  
    // **Step 6: Add the new label**
    tmpSublabel1[labelindx].timings.push({ ...currentTime });
  
    setselectedLabelTab({
      ...selectedLabelTab,
      accindex: labelindx,
      timingindx: tmpSublabel1[labelindx].timings.length - 1,
      currentGrabbed: "start",
      ...tmpSublabel1[labelindx].timings[tmpSublabel1[labelindx].timings.length - 1],
    });
    setsubLabelTimings(tmpSublabel1);
}

const findAvailableSpaceForLabel = (labelIndex) => {
  const tmpSublabels = [...sublabelTimings];
  const timings = [...tmpSublabels[labelIndex].timings].sort((a, b) => a.start - b.start);

  const requiredDuration = 20;
  const framePadding = frameTimeLimit * 2;

  let lastEnd = 0;
  let largestAvailable = null;

  for (let i = 0; i < timings.length; i++) {
    const row = timings[i];
    const availableSpace = row.start - lastEnd;

    if (availableSpace >= requiredDuration + framePadding) {
      return { start: lastEnd + framePadding, end: lastEnd + requiredDuration };
    }

    if (!largestAvailable || availableSpace > (largestAvailable.end - largestAvailable.start)) {
      largestAvailable = { start: lastEnd + framePadding, end: row.start };
    }

    lastEnd = row.end;
  }

  // Check if fits after the last label
  if (videoTiming - lastEnd >= requiredDuration + framePadding) {
    return { start: lastEnd + framePadding, end: lastEnd + requiredDuration };
  }

  // Fallback: use the largest available block if possible
  if (largestAvailable && (largestAvailable.end - largestAvailable.start > framePadding)) {
    return largestAvailable;
  }

  return false; // No available space found
};

  const addExtramargins = (labelindx) => {
    let tmpSublabel = [...sublabelTimings];
    let tmpSublabel1 = [...sublabelTimings];
    let crntSltdLabel = { ...selectedLabelTab };
    let val = {}, arrval = [],currentTime={};
    while (true) {
      if(findAvailableSpaceForLabel(labelindx)){
      let breakLoop = true;
      currentTime = {
        start:
        crntSltdLabel?.accindex == -1
            ? 0
            : crntSltdLabel?.end < videoTiming - 20 - (frameTimeLimit * 2)
              ? crntSltdLabel.end + (frameTimeLimit * 2): 0,
              // : crntSltdLabel?.start > 20 + (frameTimeLimit * 2) ? crntSltdLabel.start - 20 - (frameTimeLimit * 2) : 0,
        end:
        crntSltdLabel?.accindex == -1
            ? 20
            : crntSltdLabel?.end < videoTiming - 20 - (frameTimeLimit * 2)
              ? crntSltdLabel.end + 20 : 20,
              // : crntSltdLabel?.start > 20 + (frameTimeLimit * 2) ? selectedLabelTab?.start - (frameTimeLimit * 2) : 20,
      }


      
      if (arrval.includes(JSON.stringify(currentTime))) {
        tmpSublabel1[labelindx].timings = [
          ...tmpSublabel[labelindx].timings,
          {
            ...currentTime
          },
        ];
        // setAlertMessage({
        //   Errortype: "Info",
        //   title: "Overlap Issue",
        //   message: "Cannot add new label time",
        // });
        // openAlertPopup();
        check_available_space_add_label(labelindx);
        breakLoop=true;
        return;
      }

      arrval.push(JSON.stringify(currentTime));

      for (let i = 0; i < tmpSublabel1[labelindx].timings.length; i++) {
        let rowtime = tmpSublabel1[labelindx].timings[i];
        val = currentTime;
        if (currentTime?.start <= rowtime?.start && currentTime?.end >= rowtime?.end ||
          currentTime?.start >= rowtime?.start && currentTime?.end <= rowtime?.end ||
          currentTime?.start > rowtime?.start && currentTime?.start < rowtime?.end ||
          currentTime?.end > rowtime?.start && currentTime?.end < rowtime?.end
        ) {
          crntSltdLabel = {
            ...selectedLabelTab,
            accindex: labelindx,
            timingindx: i,
            ...currentTime,
            currentGrabbed: "start"
          }
          breakLoop = false;
          break;
        }
        if (i == tmpSublabel1[labelindx]?.timings.length - 1) {
          breakLoop = true;
          break;
        }
      }

      if (breakLoop) {
        tmpSublabel1[labelindx].timings = [
          ...tmpSublabel[labelindx].timings,
          {
            ...currentTime
          },
        ];
        break;
      }
      }else{
    setAlertMessage({
      Errortype: "Info",
      title: "No Space Available",
      message: "Cannot add new label",
    });
    openAlertPopup();
    return;
  }
    }
      let existingLabels=sublabelTimings[labelindx].timings,newLabel=currentTime
      for (let label of existingLabels) {
        if (
          (newLabel.start >= label.start && newLabel.start < label.end) || // New label starts inside an existing label
          (newLabel.end > label.start && newLabel.end <= label.end) || // New label ends inside an existing label
          (newLabel.start <= label.start && newLabel.end >= label.end) // New label completely covers an existing label
        ) {
          break;
        }
      }
    

    if (!(selectedLabelTab?.start >= 0 || selectedLabelTab?.end >= 0)) {
      setselectedLabelTab({
        ...selectedLabelTab,
        ...sublabelTimings[labelindx].timings[selectedLabelTab.timingindx],
      });
    }
    setselectedLabelTab({
      ...selectedLabelTab,
      accindex: labelindx,
      timingindx: tmpSublabel[labelindx].timings.length - 1,
      currentGrabbed: "start",
      ...tmpSublabel[labelindx].timings[(tmpSublabel[labelindx].timings.length - 1)],
    })
    setsubLabelTimings(tmpSublabel);
  };
// ---------------------------------------------------------------------------------------------
  const deleteEntireLabel = (labelindx) => {
    let tmpSublabel = [...sublabelTimings],
      sblbl = [];
    for (let i = 0; i < tmpSublabel.length; i++) {
      if (i != labelindx) {
        sblbl.push(tmpSublabel[i]);
      }
    }
    setsubLabelTimings(sblbl);
  };
  const calculateMedian = (numbers) => {
    const sorted = Array.from(numbers).sort((a, b) => a - b);
    const middle = Math.floor(sorted.length / 2);

    if (sorted.length % 2 === 0) {
      return (sorted[middle - 1] + sorted[middle]) / 2;
    }

    return sorted[middle];
  }

  const calculateArraySum=(arr)=>{
    return arr.reduce((a,b)=>a+b,0)
  }

  const findMinMaxAvgMedian = (arr,timeDiff) => {
    var sum=arr.reduce((a,b) => a+b,0)
    var sumOfClasses = []; // sum
    Object.keys(timeDiff).map((item, index) => {
      let classTotalFrames=timeDiff[item].reduce((a,b)=>a+b,0)
      sumOfClasses.push(classTotalFrames*frameCount)
    })
    var min = arr[0],minIndx=0; // min
    var max = arr[0],maxIndx=0; // max
    for (var i = 1; i < sumOfClasses.length; i++) {
      if (sumOfClasses[i] < min) {
        min = sumOfClasses[i];
        minIndx=i
      }
      if (sumOfClasses[i] > max) {
        max = sumOfClasses[i];
        maxIndx=i;
      }
    }
    let median = calculateMedian(arr);
    let mean = Math.round(sum / arr.length);
    return {
      mean, median, min:`${Object.keys(timeDiff)[minIndx]}(${Math.round(min)})`, max:`${Object.keys(timeDiff)[maxIndx]}(${Math.round(max)})`
    }
  }

  const calculateAnalyticFields=()=>{
    let timeDiff = getLabelClassMean();
    let overallDiffFrameList = [];
    if (Object.keys(timeDiff).length != 0) {
      Object.keys(timeDiff).map((item, index) => {
        timeDiff[item].length > 0 && timeDiff[item].map((diff, index) => {
          let diffFrameCount = Math.round(diff * frameCount);
          overallDiffFrameList.push(diffFrameCount)
        })
      })
    }
    let analyticValues = findMinMaxAvgMedian(overallDiffFrameList,timeDiff)
    setAnalyticData({
      ...analyticValues
    })
  }

  const handleMouseMoveWhenGrabbed = (event, accindex = 0, index = 0, type) => {
    try {
      playVideoRef.current.currentTime = 0;
      roiDrawRef.current.currentTime = 0;
      let playbackRect = playBackBarRef.current.getBoundingClientRect();
      if (
        (event?.clientX > playbackRect.left &&
          event?.clientX < playbackRect.right) ||
        event?.type == "frames"
      ) {
        handlePauseVideo();
        addActiveSegments();

        let seekRatio = 0;
        let time = [sublabelTimings[accindex].timings[index]];
        let seek = 0;
        if (event?.type == "frames") {
          seekRatio = event.seekratio;
          seek = event.time;
        } else {
          seekRatio = (event.clientX - playbackRect.left) / playbackRect.width;
          seek = parseFloat(
            (
              Math.floor(
                (playVideoRef.current.duration * seekRatio) /
                frameTimeLimit
              ) * frameTimeLimit
            ).toFixed(2)
          );
        }
        let timeframe = [...sublabelTimings];
        let time1 = timeframe[accindex].timings[index];
        let end = time1.end - time1.start;

        let isOverlapping = false;
        sublabelTimings[accindex].timings.map((item, labletimeindex) => {
          if (labletimeindex != index) {
            if (
              (seek > parseFloat(item?.start) && seek < parseFloat(item?.end)) ||
              (type == "start" &&
                seek < parseFloat(item?.start) &&
                parseFloat(sublabelTimings[accindex]?.timings[index]?.end) >
                parseFloat(item?.end)) ||
              (labletimeindex != index &&
                type == "end" &&
                seek > parseFloat(item?.end) &&
                parseFloat(sublabelTimings[accindex]?.timings[index]?.start) <
                parseFloat(item?.start)) ||
              (type == "complete" &&
                seek < parseFloat(item?.start) &&
                parseFloat(seek + end) > parseFloat(item?.end))
            ) {
              isOverlapping = true;
            }
          }
        });
        if (!isOverlapping) {
          if (type === "start" && seek < time[0]?.end - 0.2) {
            progressBarRef.current.style.left = `${seekRatio * 100}%`;
            progressBarRef1.current.style.left = `${seekRatio * 100}%`;
            time[0]["start"] = seek;
            sublabelTimings[accindex].timings[index] = time[0];
            setPlaying(false);
          } else if (type == "start") {
            setAlertMessage({
              Errortype: "Info",
              title: "Overlap Issue",
              message: "Start should not be greater than End",
            });
            openAlertPopup();
          }
          if (type === "end" && seek > time[0]?.start + 0.2) {
            progressBarRef.current.style.left = `${(time[0].start / playVideoRef.current.duration) * 100
              }%`;
            progressBarRef1.current.style.left = `${(time[0].start / playVideoRef.current.duration) * 100
              }%`;
            time[0]["end"] = seek;
            sublabelTimings[accindex].timings[index] = time[0];
            setPlaying(false);
          } else if (type == "end") {
            setAlertMessage({
              Errortype: "Info",
              title: "Overlap Issue",
              message: "End should not be less than Start",
            });
            openAlertPopup();
          }

          if (type === "complete") {
            seekRatio = (event.clientX - playbackRect.left) / playbackRect.width;
            seek = parseFloat(
              (
                Math.floor(
                  (playVideoRef.current.duration * seekRatio) /
                  frameTimeLimit
                ) * frameTimeLimit
              ).toFixed(2)
            );
            if (seek > 0 && seek + end < videoTiming) {
              time1["start"] = seek;
              time1["end"] = seek + end;
              timeframe[accindex].timings[index] = time1;
              setsubLabelTimings(timeframe);
            }
            setPlaying(false);
          }

          setsubLabelTimings(sublabelTimings);
          onSelectSublabel(accindex, index, type);
          progressBarRef.current.style.width = "0%";
          progressBarRef1.current.style.width = "0%";
        } else {
          setAlertMessage({
            Errortype: "Info",
            title: "Overlap Issue",
            message: "Labels Should not overlap",
          });
          openAlertPopup();
        }
      }
    } catch (err) {
      setAlertMessage({
        Errortype: "Error",
        title: "Error",
        message: { err },
      });
      openAlertPopup();
    }
    calculateAnalyticFields();
  };

  const handleMouseMoveWhenframeGrabbed = (event, type) => {
    try {
      let playbackRect = playBackBarRef.current.getBoundingClientRect();
      if (
        event?.clientX > playbackRect.left &&
        event?.clientX < playbackRect.right
      ) {
        let seekRatio = 0;
        let timeframe = { ...selectedLabelTab };
        let time = timeframe.frameLabel;
        let seek = 0;
        seekRatio = (event.clientX - playbackRect.left) / playbackRect.width;
        seek = parseFloat(
          (
            Math.floor(
              (playVideoRef.current.duration * seekRatio) /
              frameTimeLimit
            ) * frameTimeLimit
          ).toFixed(2)
        );
        let end = time.end - time.start;
        if (type === "start" && seek < time?.end - 0.2) {
          time["start"] = time.end - seek > 300 ? time.end - 300 : seek;
          if (time?.end - seek > 300) {
            setAlertMessage({
              Errortype: "Error",
              title: "Time Exceeded",
              message: "time difference should not exceed 5 mins",
            });
            openAlertPopup();
          }
          timeframe.frameLabel = time;
        } else if (type === "end" && seek > time?.start + 0.2) {
          time["end"] = seek - time.start > 300 ? time.start + 300 : seek;
          if (seek - time?.start > 300) {
            setAlertMessage({
              Errortype: "Error",
              title: "Time Exceeded",
              message: "time difference should not exceed 5 mins",
            });
            openAlertPopup();
          }
          timeframe.frameLabel = time;
        } else if (type === "complete" && seek > 0 && seek + end < videoTiming) {
          seekRatio = (event.clientX - playbackRect.left) / playbackRect.width;
          seek = parseFloat(
            (
              Math.floor(
                (playVideoRef.current.duration * seekRatio) /
                frameTimeLimit
              ) * frameTimeLimit
            ).toFixed(2)
          );
          let end = time.end - time.start;
          time["start"] = seek;
          time["end"] = seek + end;
          timeframe.frameLabel = time;
        } else {
          return;
        }
        setselectedLabelTab(timeframe);
      }
    } catch (err) {
      setAlertMessage({
        Errortype: "Error",
        title: "Error",
        message: { err },
      });
      openAlertPopup();
    }
  };

  const addActiveSegments = () => {
    let colors = "";
    let counter = 0;
    colors += `, rgb(240, 240, 240) 0%, rgb(240, 240, 240) ${(timings[0].start / playVideoRef.current.duration) * 100
      }%`;
    for (let times of timings) {
      if (counter > 0) {
        colors += `, rgb(240, 240, 240) ${(timings[0].end / playVideoRef.current.duration) * 100
          }%, rgb(240, 240, 240) ${(times.start / playVideoRef.current.duration) * 100
          }%`;
      }
      colors += `, #ccc ${(times.start / playVideoRef.current.duration) * 100
        }%, #ccc ${(times.end / playVideoRef.current.duration) * 100}%`;
      counter += 1;
    }
    colors += `, rgb(240, 240, 240) ${(timings[0].end / playVideoRef.current.duration) * 100
      }%, rgb(240, 240, 240) 100%`;
    playBackBarRef.current.style.background = `linear-gradient(to right${colors})`;
  };

  const handlePlayVideo = async () => {
    try {
      await playVideoRef?.current?.play();
      await roiDrawRef?.current?.play();
    } catch (error) {
      if (error?.name === 'AbortError') {
        console.warn('The play request was interrupted by a pause:', error);
      } else {
        console.error('Video play failed:', error);
      }
    }
  };

  const handlePauseVideo = async () => {
    try {
      await playVideoRef?.current?.pause();
      await roiDrawRef?.current?.pause();
    } catch (error) {
      console.error('Video pause failed:', error);
    }
  };

  const onSelectSublabel = (
    accindex,
    indx,
    type = "start",
    isSelectLabelEnabled = false
  ) => {
    if (
      isSelectLabelEnabled == false ||
      selectedLabelTab?.accindex == -1 ||
      !(
        selectedLabelTab?.accindex == accindex &&
        indx == selectedLabelTab?.timingindx
      )
    ) {
      setframes([]);
      setselectedLabelTab({
        ...sublabelTimings[accindex].timings[indx],
        accindex: accindex != undefined ? accindex : 0,
        timingindx: indx != undefined ? indx : 0,
        currentGrabbed: type,
        frameLabel: selectedLabelTab.frameLabel,
      });
    } else {
      setselectedLabelTab({
        ...sublabelTimings[accindex].timings[indx],
        accindex: -1,
        timingindx: -1,
        currentGrabbed: undefined,
        frameLabel: selectedLabelTab.frameLabel,
      });
    }
  };

  const getTimeandFrame = (time) => {
    if (time) {
      let seconds = parseFloat(time.toFixed(10));
      let mins = [scameTimeMeasure].reduceRight(
        (p, b) => (r) => [Math.floor(r / b)].concat(p(r % b)),
        (r) => [r]
      )(seconds);
      let secs = mins[1]
        ? [1].reduceRight(
          (p, b) => (r) => [Math.floor(r / b)].concat(p(r % b)),
          (r) => [r]
        )(mins[1])
        : [0, 0];
      let frametimeinful = frameTimeLimit * 100;
      let frame = 0;
      if ((1 / frameTimeLimit) % 1 != 0) {
        frametimeinful = frameTimeLimit.round(5) * 100;
        let secsMultipliedVal = (secs[1].round(5) * 100) >= 1 ? (secs[1].round(5) * 100) : 0;
        frame = Math.floor(secsMultipliedVal / frametimeinful);
        frame = frame % frameCount;
      } else {
        frame = Math.floor((secs[1].round(digitslngth) * 100) / frametimeinful);
      }
      return `${mins[0] < 10 ? '0' + mins[0] : mins[0]}:${secs[0] < 10 ? '0' + secs[0] : secs[0]}.${(frame + 1) < 10 ? '0' + (frame + 1) : frame + 1}`;
    }
    return "0.0:0";
  };
  const closeCurrentEditable = () => {
    setEditableInp({
      accindex: -1,
      timingindx: -1,
      currentGrabbed: '',
      currentValue: ''
    })
  }

  const gettimeEntered = (timeVal) => {
    let timeFrames = timeVal.split(/[\:\.]+/);
    let givenTimeFrame = 0, timeMultiply = [60, 1, frameTimeLimit], limit = [-1, 60, frameCount], validInp = true;
    let framedigit = digitslngth;
    for (let i = 0; i < timeFrames.length; i++) {
      let inputValue = parseInt(timeFrames[i])

      if (limit[i] == -1 || inputValue <= limit[i]) {
        if (i == 2) {
          if ((1 / frameTimeLimit) % 1 != 0) {
            framedigit = 5
          }
          givenTimeFrame = givenTimeFrame + (timeFrames[i] * timeMultiply[i].round(framedigit))
        } else {
          givenTimeFrame = givenTimeFrame + (timeFrames[i] * timeMultiply[i])
        }
      } else {
        validInp = false;
        break;
      }
    }
    if (givenTimeFrame > videoTiming || !validInp) {
      return -1;
    }
    givenTimeFrame = givenTimeFrame - frameTimeLimit.round(framedigit);
    return givenTimeFrame;
  }

  const handleKeyDown = (e) => {
    let regexp = /[0-9]+[\:]*[0-9]*[\.]*[0-9]*/
    if (e.key === 'Enter' && editableInp?.accindex != -1 && editableInp?.timingindx != -1 && editableInp?.currentGrabbed != '') {
      if (regexp.test(editableInp?.currentValue)) {
        let timeval = gettimeEntered(editableInp.currentValue);
        if (timeval != -1) {
          handleMouseMoveWhenGrabbed({
            type: 'frames',
            seekratio: timings[0].start / playVideoRef.current.duration,
            time: timeval
          }, editableInp.accindex, editableInp.timingindx, editableInp.currentGrabbed);
          // sublabelTimingscpy[editableInp.accindex].timings[editableInp.timingindx][editableInp.currentGrabbed]=gettimeEntered(editableInp.currentValue);
          // setsubLabelTimings(sublabelTimingscpy);
          closeCurrentEditable();
        } else {
          setAlertMessage({
            Errortype: "Error",
            title: "Invalid Input",
            message: "Valid Time must be provided",
          });
          openAlertPopup();
        }
      } else {
        setAlertMessage({
          Errortype: "Error",
          title: "Invalid Input",
          message: "Valid Time must be provided",
        });
        openAlertPopup();
      }
    }
  }

  const editableOnchangeHandler = (e) => {
    const regEx = /\d*/;
    let inpVal = e.target.value.replace(/[^0-9]+/g, "");
    if (inpVal.length < 7 && regEx.test(inpVal)) {
      let arrvl = inpVal.split(""), finalStr = '';
      for (let i = 0; i < arrvl.length; i++) {
        finalStr = finalStr + (i == 2 ? ':' + arrvl[i] : i == 4 ? '.' + arrvl[i] : arrvl[i]);
      }
      setEditableInp({
        ...editableInp,
        currentValue: finalStr
      })
    }
  }

  // onchange handlers for the label selectors

  const handleToggleSelectAll = () => {
    setSelectAll((prev) => {
      if (!prev) setfilteredSublabelTimings([...sublabelTimings]);
      else setfilteredSublabelTimings([]);
      return !prev;
    });
  };

  const roiOnChangeHandler = (e) => {
    if (e.target.value != 0) {
      setShowCroppedVideo(false)
      setEnableROI(false)
    } else {
      setSelectedEditableROIindex(-1);
    }
    setSelecteROIindex(e.target.value);
    setZoomAreaRatio({ ...roiList[e.target.value] })
  }
  const saveTheAnnotationData = (roiList) => {
    handleSubmit(sublabelTimings, roiList)
  }

  const handleMetaFileDownload = () => {
    download_meta_file(urlParams.backendId, urlParams.collectionPath);
  }

  const handleDownloadVideoFrames = () => {
    try {
      setEportFrameLoader(true)
      let measurementValues = { x: 0, y: 0, width: 0, height: 0 }
      if (selecteROIindex > 0) {
        measurementValues = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, roiList[selecteROIindex].x, roiList[selecteROIindex].y, roiList[selecteROIindex].width, roiList[selecteROIindex].height);
      }
      download_video_frames(urlParams.backendId, urlParams.collectionPath, roiList[selecteROIindex]?.roi_id ? roiList[selecteROIindex].roi_id : -1
        , measurementValues.x
        , measurementValues.y
        , measurementValues.width
        , measurementValues.height,
        frameInterval).then(() => {
          setAlertMessage({
            Errortype: "Success",
            title: "Success",
            message: 'Export completed',
          });
          openAlertPopup();
          setEportFrameLoader(false)
          handleCloseLabelSelector();
        }).catch((e) => {
          setAlertMessage({
            Errortype: "Error",
            title: "Error",
            message: e,
          });
          openAlertPopup();
          setEportFrameLoader(false)
          handleCloseLabelSelector();
        })
    } catch (e) {
      setAlertMessage({
        Errortype: "Error",
        title: "Error",
        message: e,
      });
      openAlertPopup();
      setEportFrameLoader(false)
      handleCloseLabelSelector();
    }
  }

  const handleSubmitMeasurements = (measures) => {
    let pxToPercentage = calculateBoxPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, measures.x, measures.y, measures.width, measures.height);
    let percentageToPixel = calculateBoxFromPercentage(visibleVideoDimensions.width, visibleVideoDimensions.height, pxToPercentage.x, pxToPercentage.y, pxToPercentage.width, pxToPercentage.height);
    setZoomArea(percentageToPixel);
  }
  const getLabelClassMean = () => {
    let timeDiffList = {};
    sublabelTimings.map((sibling, accindex) => {
      sibling.timings.map((timing, index) => {
        if (timeDiffList[sibling.subname] == undefined) {
          let diff = timing.end - timing.start;
          timeDiffList[`${sibling.subname}`] = [diff]
        } else {
          timeDiffList[sibling.subname].push(timing.end - timing.start)
        }
      })
    })
    return timeDiffList;
  }


  const leftMove = playVideoRef?.current?.currentTime ? (playVideoRef.current.currentTime / playVideoRef.current.duration) * 100 : 0;

  return (
    <div onClick={closeCurrentEditable}>
      <div className='wrapper'>
        <div className='videoAndLabelWrapper'>
          <div style={{ marginLeft: window.screen.availWidth > 1400 ? '-1.1%' : '-1.5%', position: 'absolute' }}>
            <FontAwesomeIcon icon={faExclamationCircle}
              style={{ marginRight: '10px', cursor: 'pointer' }}
              onClick={() => {
                setmodalType('shortcuts');
                handleOpenLabelSelector();
              }} />
            <span style={{ color: 'green' }}>{frameLabels.current}</span>
          </div>
          <div className='videoContainer'>
            <ROISelector
              isMuted={isMuted}
              setSeekerBar={setSeekerBar}
              vidsrc={videoUrl}
              progressBarTime={progressBarTime}
              zoomAreaRatio={zoomAreaRatio}
              setZoomAreaRatio={setZoomAreaRatio}
              zoomArea={zoomArea}
              setZoomArea={setZoomArea}
              visibleVideoDimensions={visibleVideoDimensions}
              setVisibleVideoDimensions={setVisibleVideoDimensions}
              showCroppedVideo={showCroppedVideo}
              setShowCroppedVideo={setShowCroppedVideo}
              enableROI={enableROI}
              playPause={playPause}
              selecteROIindex={selecteROIindex}
              setSelecteROIindex={setSelecteROIindex}
              roiList={roiList}
              addRoiCoordinates={addRoiCoordinates}
              updateRoiCoordinates={updateRoiCoordinates}
              deleteRoiCoordinates={deleteRoiCoordinates}
              setroiList={setroiList}
              openAlertPopup={openAlertPopup}
              setAlertMessage={setAlertMessage}
              saveTheAnnotationData={saveTheAnnotationData}
              setMeasurements={setMeasurements}
              selectedEditableROIindex={selectedEditableROIindex}
              setSelectedEditableROIindex={setSelectedEditableROIindex}
              urlParams={urlParams}
              ref={{ progressBarRef, playVideoRef, roiDrawRef }}
              setEnableROI={setEnableROI}
            />
            <div
              className='playback playbackVideo'
            >
              <div
                className='seekable'
                ref={playBackBarRef1}
                onClick={(e) => updateProgress(e, true, true)}
              ></div>
              <div
                className='progress_bar_for_video'
              ></div>
              <div className='progress' ref={progressBarRef1}></div>
            </div>
            <div className='controls'>
              <div className='player-controls'>
                <button
                  className='play-control videoPlayPuase'
                  title='Play/Pause'
                  style={{width: enableROI ? "15vw" : "auto",marginLeft: enableROI ? "-27vh" : "0px"}}
                  onClick={() => playPause(true)}
                >
                  {playing ? (
                    <FontAwesomeIcon icon={faPause} />
                  ) : (
                    <FontAwesomeIcon icon={faPlay} />
                  )}
                </button>
              </div>
              <div className='player-controls'>
              <button
                  className='analytic-chart-data'
                  title='Chart Data'
                  onClick={handleOpenChartData}
                ><FontAwesomeIcon icon={faChartBar} />
                </button>
                <button
                  className='meta-downloader'
                  title='Download Meta File'
                  onClick={handleMetaFileDownload}
                ><FontAwesomeIcon icon={faDownload} />
                </button>
                <select
                  id="speedControl"
                  className="video-speed-controller"
                  value={playbackRate}
                  onChange={handleSpeedChange}
                >
                  {[0.25, 0.5, 0.75, 1, 2, 3].map((speed) => (
                    <option key={speed} value={speed}>
                      {speed}X
                    </option>
                  ))}
                </select>
                {/* <button
                  className='settings-control'
                  title='Mute/Unmute Video'
                  onClick={()=>setIsMuted(!isMuted)}
                >
                  {isMuted ? (
                    <FontAwesomeIcon icon={faVolumeMute} />
                  ) : (
                    <FontAwesomeIcon icon={faVolumeUp} />
                  )}
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={openChartData}
        onClose={handleCloseChartData}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        style={{ background: 'none', }}
        className="ContainerForChartDataModal"
      >
        <Box sx={{
          ...modalStyle, width: 350, top: '45%', height: 'auto', padding: '20px'
        }}>
          <div>
            <ExportChartData rows={[
              ["Total no of Frames", `${videoTiming * frameCount}`],
              ["Mean", `${analyticData?.mean}`],
              ["Median", `${analyticData?.median}`],
              ["Min", `${analyticData?.min}`],
              ["Max", `${analyticData?.max}`]
            ]} />

          </div>
        </Box>
      </Modal>
      <div className='label_contrll_wrapper'>
        <div className='labelcontainer'>
          <div className="export_frame_button_div" style={{visibility:!enableROI ? 'visible':'hidden'}} >
            <button disabled={enableROI} className="export_frame_button " onClick={() => {
              handleOpenLabelSelector()
              setmodalType("export_frames")
            }}>Export Video Frames</button>
          </div>
          <div className="roiContainerSlider">
            {/*  {videoTiming*frameCount} */}
            <Tooltip
              title={"Applicable Only for Full Video"}
              disableHoverListener={selecteROIindex == 0}
              placement="top"
              arrow>
                <button
                  // disabled={selecteROIindex != 0}
                  className="addROIButton"
                  onClick={() => {
                    if (selecteROIindex != 0 && !enableROI) {
                      setSelectedEditableROIindex(selecteROIindex);
                      let newheight = window.screen.availHeight < 900 ? window.screen.availHeight - 128 : window.screen.availHeight - 190;
                      let widthVal = (visibleVideoDimensions.videoWidth / visibleVideoDimensions.videoheight) * newheight;
                      let measurementValues = calculateBoxFromPercentage(widthVal, newheight, roiList[selecteROIindex].x, roiList[selecteROIindex].y, roiList[selecteROIindex].width, roiList[selecteROIindex].height);
                      measurementValues = { ...measurementValues, editable: false }
                      setZoomArea(measurementValues);
                      setSelecteROIindex(0)
                    } else {
                      setZoomArea(null);
                      setSelectedEditableROIindex(-1);
                    }
                    setShowCroppedVideo(false)
                    setEnableROI(!enableROI);
                  }}
                >{enableROI ? <><FontAwesomeIcon icon={faTimes} /> Cancel</>  : selecteROIindex != 0 ? "Edit ROI" : "Add New ROI"}</button>
            </Tooltip>
            <Tooltip
              title={"ROI X,Y points,width, and height"}
              // disableHoverListener={selecteROIindex == 0}
              placement="top"
              arrow>
              <div>
                <FontAwesomeIcon icon={faExclamationCircle}
                 className="roiInfoIcon"
                  onClick={() => {
                    setmodalType('roi');
                    handleOpenLabelSelector();
                  }} />
              </div>
            </Tooltip>
          </div>
          <div className="roiContainer">
            <select
              value={selecteROIindex}
              onChange={roiOnChangeHandler}
              className='savedROISelector'
              disabled={enableROI}
              style={{ cursor: enableROI ? 'not-allowed' : 'pointer' ,visibility: enableROI ? 'hidden' : 'visible' }}
            >
              {roiList.map((label, index) => (
                <option key={`labels_option_${index}`} value={index}>
                  {index == 0 ? 'Full Video' : 'ROI ' + (roiList[index]?.roi_id)}
                </option>
              ))}
            </select>
            <hr className="roiSplitter" />
          </div>
          <button className='annotateSubmitButton' style={{visibility:!enableROI ? 'visible':'hidden'}} onClick={saveTheAnnotationData}>Save</button>
          <select
            value={currentlabel}
            onChange={(e) => onchangeHandlerLabel(e.target.value, sublabelTimings)}
            className='labelSelector'
          >
            {labelsLi.map((label, index) => (
              <option key={`labels_option_${index}`} value={label}>
                {label}
              </option>
            ))}
          </select>
          <button
            className='sublabelSelectorButton modalSubmitButton submitButton'
            onClick={() => {
              setmodalType('labelSelector')
              handleOpenLabelSelector()
            }
            }
          >
            Visible Labels
          </button>
          {/* <p style={{ marginBottom: "7%", marginTop: "10px" }}>
            sublabels{" "}
             <button onClick={handleOpen} className='labelbuttons'>
              add sublabel
            </button> 
          </p> */}
          <Modal
            open={openlabelSelector} onClose={handleCloseLabelSelector}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
            style={{ background: 'none', }}
            className="ContainerForTheAnnoatatorModal"
          >
            <Box sx={{
              ...modalStyle, width: 350, top: modalType == 'shortcuts' ? '16%'
                // : modalType == 'roi' ? '63%' 
                : '45%'
            }}>
              {
                modalType == 'shortcuts' ? <div className="alertMessage">
                  <h4>ShortCuts</h4>
                  <div>
                    {shortCutsList.map((shortcut, index) => (
                      <li key={`shortCutKeys${index}`}>
                        <span>{shortcut.key}</span>=<span style={{ color: 'green' }}>{shortcut.event}</span>
                      </li>
                    ))}
                  </div>
                </div> :
                  modalType == 'roi' ? <div className="containerForRoiModal">
                    <MeasurementsModal measurements={measurements} setMeasurements={setMeasurements} handleSubmitMeasurements={handleSubmitMeasurements} setAlertMessage={setAlertMessage} openAlertPopup={openAlertPopup} visibleVideoDimensions={visibleVideoDimensions} showCroppedVideo={showCroppedVideo} enableROI={enableROI} selecteROIindex={selecteROIindex} roiList={roiList} selectedEditableROIindex={selectedEditableROIindex} />
                  </div>
                    : modalType == 'export_frames' ?
                      <div className="alertMessage">
                        <h4 className="frame_export_header">Please Enter the Frame Interval</h4>
                        <div className="frame_export_inp_container">
                          {exportFrameLoader ?
                            <div className="frame_download_loader"> <GradientCircularProgress /></div>
                            : <>
                              <input className="frame_interval_input" type="number" value={frameInterval} onChange={(e) => /[0-9]*/.test(e.target.value) && parseInt(e.target.value) > 0 && parseInt(e.target.value) <= frameCount && setFrameInterval(e.target.value)} />
                              <button className="frame_download_submit_button" onClick={handleDownloadVideoFrames}><FontAwesomeIcon icon={faDownload} /> Download Video Frames</button>
                            </>}
                        </div>
                      </div>
                      :
                      <>
                        <div>
                          <div className="alertMessage">
                            <h4>Visible SubLabels</h4>
                          </div>
                          <Stack spacing={3} sx={{ width: '96%' }}>
                            <Autocomplete
                              multiple
                              style={{
                                marginTop: `${window.screen.availHeight < 850 ? '4.5%' : '8%'}`, marginLeft: '2%', height: '100px', paddingTop: '7px', overflowY: 'auto'
                              }}
                              id={"autocomplete_with_select_all"}
                              fullWidth
                              options={sublabelTimings}
                              getOptionLabel={(sibling) => sibling.subname}
                              defaultValue={filteredSublabelTimings}
                              value={filteredSublabelTimings}
                              selectOnFocus={false}
                              freeSolo={false}
                              onChange={(_e, value, reason) => {
                                if (reason === "clear" || reason === "removeOption")
                                  setSelectAll(false);
                                if (reason === "selectOption" && value.length === sublabelTimings.length)
                                  setSelectAll(true);
                                setfilteredSublabelTimings(value);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label={"SubLabels"} />
                              )}
                              PaperComponent={(paperProps) => {
                                const { children, ...restPaperProps } = paperProps;
                                return (
                                  <Paper {...restPaperProps} style={{ padding: '0px 16px', marginTop: '0px' }}>
                                    <Box
                                      onMouseDown={(e) => e.preventDefault()} // prevent blur
                                      pl={1.5}
                                      py={0.5}
                                    >
                                      <FormControlLabel
                                        onClick={(e) => {
                                          e.preventDefault(); // prevent blur
                                          handleToggleSelectAll();
                                        }}
                                        style={{ padding: '0px', marginTop: '0px', background: 'none', color: 'black', width: '100%' }}
                                        label="Select all"
                                        control={
                                          <Checkbox id="select-all-checkbox" checked={selectAll} />
                                        }
                                      />
                                    </Box>
                                    <Divider />
                                    {children}
                                  </Paper>
                                );
                              }}
                              clearOnEscape={true}
                              disableCloseOnSelect={true}
                            />
                          </Stack>
                        </div></>
              }

            </Box>
          </Modal>
          <ul className='unorderListStyle' style={{ height: `${labelContainerHeight}px` }} onScroll={handleScrollSecond} ref={secondDivRef}>
            {sublabelTimings &&
              sublabelTimings.map((sibling, indx) =>
                [...(filteredSublabelTimings.map((sibling1) => sibling1.subname))].includes(sibling.subname) ?
                  (
                    <li
                      key={`sublabel_list_${indx}`}
                      className='listStyleForLabels'
                      style={{ marginTop: JSON.stringify(filteredSublabelTimings[0]) == JSON.stringify(sibling) ? '23px' : '0px', marginBottom: JSON.stringify(filteredSublabelTimings[filteredSublabelTimings.length - 1]) == JSON.stringify(sibling) ? '18px' : '27px' }}
                    >
                      {indx + 1}. {sibling.subname}{" "}
                      <button
                        onClick={() => addExtramargins(indx)}
                        className='labelbuttons'
                      >
                        add
                      </button>
                    </li>
                  ) : '')}
          </ul>
        </div>
        <div className='controller_wrapper' ref={controllerWrapperRef}>
          <div
            className='onscrollControllContainer'
          >
            <div
              className='playback playbackControllContainer'
              style={{ width: playbackLength, marginBottom: "0px" }}
            >
              <div
                className='seekable'
                ref={playBackBarRef}
                onClick={(e) => updateProgress(e, true)}
                onMouseEnter={updateProgresshoverTime}
              ></div>
              <div className='progress' ref={progressBarRef}></div>
              <p
                style={{ marginLeft: `${leftMove}` + "%" }}
                className='progress progress_time1 '
              >
                <p className='timeFrameline'>|</p>
                <p className='timeFrame' style={{ cursor: 'pointer', zIndex: '100', height: '14px' }} onClick={() => {
                  navigator.clipboard.writeText(`${getTimeandFrame(currentVideoPlayTime)}`);
                  setAlertMessage({
                    Errortype: "Info",
                    title: "Copied!!!",
                    message: "Measurements are copied",
                  });
                  openAlertPopup();
                }}>{currentVideoPlayTime ? getTimeandFrame(currentVideoPlayTime) : '0.0:0'}</p>
              </p>
              {progressBarTimStmp != -1 && (
                <p
                  style={{ marginLeft: hoverTimeLft + "%", marginTop: Math.abs(leftMove - hoverTimeLft) < 4.5 ? '14px' : '-14px' }}
                  className='progress progress_time'
                >
                  <p className='timeFrameline' style={{ visibility: Math.abs(leftMove - hoverTimeLft) < 4.5 ? 'hidden' : 'visible' }}>|</p>
                  <p className='timeFrame'>{progressBarTimStmp}</p>
                </p>
              )}
            </div>
            <div
              className='playback_timer'
              style={{ width: playbackLength, marginTop: "0.5rem" }}
              onClick={(e) => updateProgress(e, true)}
              onMouseMove={updateProgresshoverTime}
              onMouseLeave={() => setprogressBarTimStmp(-1)}
            >
              {/* time selector time line  */}
              <div className='timingcontainer'>
                <FrameTime
                  timing1={timing1}
                  n={timeEnd}
                  playbackLength={playbackLength}
                  hms={getTimeandFrame}
                  isTopController={true}
                  frameCount={frameCount}
                  frameTimeLimit={frameTimeLimit ? frameTimeLimit : 0}
                />
              </div>
            </div>
          </div>
          {/* frame seek time limit controller */}
          {/* <div
            className='playback'
            style={{ marginBottom: "6rem", width: playbackLength }}
          >
            <div>
              <div key={"grabber_frames"}>
                <div
                  draggable
                  id='grabberStart'
                  className='grabber frammerstart'
                  style={{
                    left: `${(parseInt(selectedLabelTab.frameLabel.start) /
                      videoTiming) *
                      100
                      }%`,
                    background: frameViewColor,
                  }}
                  onDragStart={(event) => {
                    handleMouseMoveWhenframeGrabbed(event, "start");
                  }}
                  onDragEnd={(event) => {
                    handleMouseMoveWhenframeGrabbed(event, "start");
                  }}
                >
                  {"["}
                </div>
                <p
                  draggable
                  className='markerContainer completegrabber'
                  style={{
                    background: frameViewColor,
                    left: `${(parseInt(selectedLabelTab.frameLabel.start) /
                      videoTiming) *
                      100
                      }%`,
                    width: `${(selectedLabelTab?.frameLabel?.end / videoTiming) * 100 -
                      (parseInt(selectedLabelTab.frameLabel.start) /
                        videoTiming) *
                      100
                      }%`,
                  }}
                  onDragEnd={(event) => {
                    handleMouseMoveWhenframeGrabbed(event, "complete");
                  }}
                >
                  {" "}
                </p>
                <div
                  draggable
                  id='grabberEnd'
                  className='grabber framerend'
                  style={{
                    left: `${(selectedLabelTab?.frameLabel?.end / videoTiming) * 100
                      }%`,
                    background: frameViewColor,
                  }}
                  onDragEnd={(event) => {
                    handleMouseMoveWhenframeGrabbed(event, "end");
                  }}
                >
                  {"]"}
                </div>
              </div>
            </div>
            <div
              className='seekable'
              style={{ background: "rgb(203, 235, 250)" }}
              onClick={(e) => updateProgress(e, true)}
            ></div>
            <div className='progress'></div>
          </div> */}
          {isFrameEnabled && (
            <SelectedTimeFrame
              selectedLabelTab={selectedLabelTab}
              timing1={[
                0.0,
                ...timeFrameLimit
                ,
                ...timing1,
              ]}
              key={
                selectedLabelTab.frameLabel.end -
                selectedLabelTab.frameLabel.start +
                selectedLabelTab.frameLabel.accindex +
                selectedLabelTab.frameLabel.timingindx
              }
              n={timing1.length + frameCount}
              getTimeandFrame={getTimeandFrame}
              updateProgress={updateProgress}
              scrollBarRef={scrollBarRef}
              frameCount={frameCount}
              frameTimeLimit={frameTimeLimit}
              sublabelTimings={sublabelTimings}
            />
          )}
          <hr
            className='seperatorLine'
            style={{ width: window.screen.availWidth * 0.97 }}
          />
          {/* {isGetFrameChecked ? (
            frames?.length > 0 ? (
              <div className='output'>
                {frames.map((frame, index) => (
                  <img
                    className='framesImgViewer'
                    onClick={(e) => handleClick(e, frame.imgUrl, index)}
                    key={`vodeo_frames_${index}`}
                    src={frame.imgUrl}
                    alt=''
                  />
                ))}
              </div>
            ) : (
              <p className='output'>loading....</p>
            )
          ) : (
            ""
          )} */}

          <div id='videannotateLabelsTimerView' className="videoAnnotateLabelContainer" style={{ width: playbackLength + 45, height: `${labelContainerHeight}px` }} onScroll={handleScrollFirst} ref={firstDivRef}>
            {sublabelTimings &&
              sublabelTimings.map((sibling, accindex) =>
                [...(filteredSublabelTimings.map((sibling1) => sibling1.subname))].includes(sibling.subname) &&
                (
                  <div
                    className={`playback ${accindex == 0 ? "playbackMarkedItems" : ""
                      }`}
                    onClick={updateProgress}
                    key={accindex}
                    style={{
                      width: playbackLength,
                      marginTop: `${(JSON.stringify(filteredSublabelTimings[0]) == JSON.stringify(sibling) && accindex != 0) ? window.screen.availHeight < 850 ? '36px' : '60px' : '60px'}`
                    }}
                  >
                    {playVideoRef?.current
                      ? sibling?.timings.map((timing, index) => (
                        <div key={index}>
                          <div
                            key={"grabber_" + index}
                          >
                            <div
                              draggable
                              id='grabberStart'
                              className={`start ${accindex == selectedLabelTab?.accindex &&
                                index == selectedLabelTab?.timingindx
                                ? "currentSelectedTab"
                                : "grabber"
                                }`}
                              style={{
                                left: `${(parseInt(timing.start) / videoTiming) * 100
                                  }%`,
                                background:
                                  accindex == selectedLabelTab?.accindex &&
                                    index == selectedLabelTab?.timingindx
                                    ? selectedLabelTab.currentGrabbed == "start"
                                      ? "green"
                                      : "black"
                                    : grabberColors[accindex],
                                zIndex:
                                  accindex == selectedLabelTab.accindex &&
                                  index == selectedLabelTab.timingindx &&
                                  "100 !important",
                              }}
                              onClick={() =>
                                onSelectSublabel(accindex, index, "start")
                              }
                              onDragStart={(event) => {
                                handleMouseMoveWhenGrabbed(
                                  event,
                                  accindex,
                                  index,
                                  "start"
                                );
                              }}
                              onDragEnd={(event) => {
                                handleMouseMoveWhenGrabbed(
                                  event,
                                  accindex,
                                  index,
                                  "start"
                                );
                              }}
                            >
                              {"["}
                              {
                                (accindex == editableInp.accindex &&
                                  index == editableInp.timingindx
                                  && editableInp.currentGrabbed == "start") ?

                                  <input value={editableInp.currentValue} onClick={(e) => e.stopPropagation()} onChange={(e) => {
                                    e.stopPropagation();
                                    editableOnchangeHandler(e)
                                  }} onKeyDown={handleKeyDown} className="hmsframeInput" />
                                  : <p
                                    className='frameTimeLines'
                                    style={{ color: "#333333" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setEditableInp({
                                        accindex: accindex,
                                        timingindx: index,
                                        currentGrabbed: 'start',
                                        currentValue: getTimeandFrame(
                                          sublabelTimings[accindex]?.timings[index]
                                            .start
                                        )
                                      })
                                    }}
                                  >
                                    {getTimeandFrame(
                                      sublabelTimings[accindex]?.timings[index]
                                        .start
                                    )}
                                  </p>

                              }
                            </div>
                            <p
                              draggable
                              className={`labelFrames ${accindex == selectedLabelTab?.accindex &&
                                index == selectedLabelTab?.timingindx
                                ? "selectedmarkerContainer"
                                : "markerContainer"
                                }`}
                              onClick={() =>
                                onSelectSublabel(accindex, index, "start", true)
                              }
                              style={{
                                background:
                                  selectedLabelTab?.accindex == accindex &&
                                    selectedLabelTab?.timingindx == index
                                    ? "repeating-linear-gradient(135deg,#fff,#fff 5px,gray 5px,gray 10px)"
                                    : grabberColors[accindex],
                                left: `${(parseInt(timing.start) / videoTiming) * 100
                                  }%`,
                                width: `${(timing?.end / videoTiming) * 100 -
                                  (parseInt(timing.start) / videoTiming) * 100
                                  }%`,
                                scale: 1,
                              }}
                              onDragEnd={(event) => {
                                handleMouseMoveWhenGrabbed(
                                  event,
                                  accindex,
                                  index,
                                  "complete"
                                );
                              }}
                            >
                              {index == selectedLabelTab?.timingindx &&
                                accindex == selectedLabelTab?.accindex && (
                                  <button
                                    className='play-control labelplaypauseControler'
                                    title='Play/Pause'
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      labelPlayPauseController(
                                        e,
                                        accindex,
                                        index,
                                        true
                                      );
                                    }}
                                  >
                                    {index == currentPlayFrame?.timingindx &&
                                      accindex == currentPlayFrame?.accindex ? (
                                      playing ? (
                                        <FontAwesomeIcon icon={faPause} />
                                      ) : (
                                        <FontAwesomeIcon icon={faPlay} />
                                      )
                                    ) : (
                                      <FontAwesomeIcon icon={faPlay} />
                                    )}
                                  </button>
                                )}
                            </p>
                            {/* Markup and logic for the end trim marker */}
                            <div
                              draggable
                              id='grabberEnd'
                              className={`end ${accindex == selectedLabelTab?.accindex &&
                                index == selectedLabelTab?.timingindx
                                ? "currentSelectedTab"
                                : "grabber"
                                }`}
                              style={{
                                left: `${(timing?.end / videoTiming) * 100}%`,
                                background:
                                  accindex == selectedLabelTab?.accindex &&
                                    index == selectedLabelTab?.timingindx
                                    ? selectedLabelTab?.currentGrabbed == "end"
                                      ? "green"
                                      : "black"
                                    : grabberColors[accindex],
                              }}
                              onClick={() =>
                                onSelectSublabel(accindex, index, "end")
                              }
                              onDragStart={(event) => {
                                handleMouseMoveWhenGrabbed(
                                  event,
                                  accindex,
                                  index,
                                  "end"
                                );
                              }}
                              onDragEnd={(event) => {
                                handleMouseMoveWhenGrabbed(
                                  event,
                                  accindex,
                                  index,
                                  "end"
                                );
                              }}
                            >
                              {"]"}
                              {
                                (accindex == editableInp.accindex &&
                                  index == editableInp.timingindx
                                  && editableInp.currentGrabbed == "end") ?

                                  <input value={editableInp.currentValue} onClick={(e) => e.stopPropagation()} onChange={(e) => {
                                    e.stopPropagation();
                                    editableOnchangeHandler(e)
                                  }} onKeyDown={handleKeyDown} className="hmsframeInput" />
                                  :
                                  <p
                                    className='frameTimeLines'
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setEditableInp({
                                        accindex: accindex,
                                        timingindx: index,
                                        currentGrabbed: 'end',
                                        currentValue: getTimeandFrame(
                                          sublabelTimings[accindex]?.timings[index]
                                            .end
                                        )
                                      })
                                    }}
                                    style={{ color: "#333333" }}
                                  >
                                    {getTimeandFrame(
                                      sublabelTimings[accindex]?.timings[index].end
                                    )}
                                  </p>
                              }
                            </div>
                          </div>
                        </div>
                      ))
                      : []}
                    <div className='seekable' onClick={updateProgress}></div>
                    <div className='progress'></div>
                    <div className='timingcontainer'>
                      <FrameTime
                        timing1={timing1}
                        n={timeEnd}
                        playbackLength={playbackLength}
                        hms={getTimeandFrame}
                        frameCount={frameCount}
                        frameTimeLimit={frameTimeLimit ? frameTimeLimit : 0}
                      />
                    </div>
                  </div>
                )
              )}
          </div>
          <div className='annotatesubmitcontainer'>
            <AlertMessageBox
              showAlertBox={showAlertBox}
              setShowAlertBox={setShowAlertBox}
              alertMessage={alertMessage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
